<template>
  <div ref="playerContainer" class="tengxunyun">
    <video
      class="tengxunyun-video"
      :id="playerId"
      preload="auto"
      playsinline
      webkit-playsinline
      style="object-fit: cover;"
    ></video>
	
	<div class="video-cover" v-if="isShowCover && backgroundUrl">
		<div class="video-cover-box">
			<img class="video-cover-box-img" :src="backgroundUrl" alt="" />
		</div>
	</div>
	<div class="zhubo-user" v-if="data.userInfo">
		<span>{{data.userInfo.nickName}}</span>
		<img
			v-if="data.isPermitMicrophone == 1" 
			class="xtzb-item-vioce" 
			src="../../assets/image/zbj_lb_jy_2@2x.png" 
			alt=""
			@click.stop="toggleMicrophone()"
		/>
		<img 
			v-if="data.isPermitMicrophone == 0" 
			class="xtzb-item-vioce" 
			src="../../assets/image/zbj_lb_jy_3@2x.png" 
			alt=""
			@click.stop="toggleMicrophone()"
		/>
	</div>
	<playSvga ref="svga" v-if="show_svga"/>
	
  </div>
</template>

<script>
import { getChatRoomDetails } from "@/api/zhibo";
import { updateHelpLiveUser } from "@/api/zhubo";
import playSvga from "../playSvga/playSvga.vue";
export default {
  name: "tengxunyunzhubo",
  components: {
    playSvga
  },
  data() {
    return {
      data: "",
      player: null,
      licenseUrl: "https://1383640469.sdk-license.com/license/v2/1383640469_1/v_cube.license",
      playerId: null,
	  show_svga:true,
	  muted:true,
	  isShowCover:true,
	  backgroundUrl:'',
	  isRefresh: sessionStorage.getItem('isPageRefreshed')
    };
  },
  mounted() {
	this.playerId = this.generateId();
    this.calculatePlayerSize();
    window.addEventListener("resize", this.calculatePlayerSize);
    this.getChatRoomDetails();
	window.addEventListener("beforeunload", this.updateRefresh)
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.calculatePlayerSize);
    if (this.player) {
      try {
        this.player.pause();
        this.player.src('');
        this.player.off('webrtcevent');
        this.player.dispose();
      } catch (e) {
        console.warn('播放器清理过程中出现异常:', e);
      }
      this.player = null;
    }
    this.playerId = null;
    this.isShowCover = true;
    this.show_svga = false;
    this.muted = true;
  },
  methods: {
	updateRefresh(){
		sessionStorage.setItem('isPageRefreshed', 1);
	},
    generateId() {
      return "player-container-" + Date.now();
    },
    calculatePlayerSize() {
      const container = this.$refs.playerContainer;
      if (!container) return;

      const parentContainer = container.parentElement;
      const parentWidth = parentContainer.offsetWidth;
      const viewportHeight = window.innerHeight;

      const maxAvailableHeight = viewportHeight - 126;
      const aspectRatio = 9 / 16;
      const calculatedWidth = maxAvailableHeight * aspectRatio;

      let finalWidth, finalHeight;

      if (calculatedWidth > parentWidth) {
        finalWidth = parentWidth;
        finalHeight = finalWidth / aspectRatio;
      } else {
        finalHeight = maxAvailableHeight;
        finalWidth = calculatedWidth;
      }

      container.style.width = `${finalWidth}px`;
      container.style.height = `${finalHeight}px`;
    },
    async getChatRoomDetails() {
      const res = await getChatRoomDetails({ liveId: this.$route.query.liveId });
	  console.log(res,1234)
      res.data.helpLiveUserList.forEach(v=>{
      	if(v.isMainScreen == 1){
      		this.data = v
      		this.backgroundUrl = v.userInfo.headPortrait;
      		
      		if (!this.player) {
      		  this.player = TCPlayer(this.playerId, {
      		    sources: [
      		      {
      		        src: v.pullUrl,
      		      },
      		    ],
      		    licenseUrl: this.licenseUrl,
      		    autoplay: true,
      		    controls: false,
      		    webrtcConfig: {
      		      connectRetryCount: 999999,
      		    },
      		  });
      		  this.player.on('webrtcevent', (event) => {
      		    if(event.data.code == 1005 || event.data.code == 1009){
      		      this.isShowCover = true
      		    }
      		    if(event.data.code == 1003){
      		      this.isShowCover = false
      		    }
      		  });
      		  this.player.on('error', (event) => {
      		    console.log(event,'视频播放出现错误时触发。')
      		  });
      		} else {
      		  this.player.src(v.pullUrl);
      		  this.player.play();
      		  this.calculatePlayerSize();
      		}
      	}
      })
    },
	async toggleMicrophone(){
		console.log(this.data)
		if(!this.data || !this.data.helpId) return;
		const newStatus = this.data.isPermitMicrophone === 1 ? 0 : 1;
		try{
			const res = await updateHelpLiveUser({
				helpId: this.data.helpId,
				isPermitMicrophone: newStatus
			});
			this.$message.success(res.msg);
			this.data.isPermitMicrophone = newStatus;
			if(this.player){
				this.player.muted(newStatus !== 1);
			}
		}catch(error){
			console.error('切换麦克风失败:', error);
		}
	},
	addGiftToQueue(data){
		this.$refs.svga.addGiftToQueue(data)
	},
	updateMuted(data){
		this.player.muted(data?false:true);
	},
	updateSvga(data){
		this.show_svga = data
	},
	refreshPlay(){
		this.isRefresh = 0
		sessionStorage.setItem('isPageRefreshed', 1);
		this.player.src(this.data.chatRoomDetails.pullUrl);
		this.player.play();
	}
  },
};
</script>

<style scoped lang="scss">
	.tengxunyun {
	  width: 100%;
	  display: flex;
	  flex-direction: column;
	  align-items: center;
	  margin: 0 auto;
	  position: relative;
	  transition: width 0.3s ease, height 0.3s ease;
	  box-sizing: border-box;
	  max-width: 100%;
	  max-height: 100%;
	}

	:deep(.tengxunyun-parent) {
	  display: flex;
	  flex-direction: column;
	  justify-content: center;
	  align-items: center;
	  height: 100%;
	}

	.tengxunyun-video {
	  width: 100%;
	  height: 100%;
	  position: relative;
	  z-index: 2;
	}
	.video-cover{
		position: absolute;
		left: 0;
		top: 0;
		right: 0;
		bottom: 0;
		z-index: 1;
	}
	.video-cover-box{
		position: relative;
		width: 100%;
		height: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}
	.video-cover-box-img{
		position: absolute;
		left: 0;
		top: 0;
		right: 0;
		bottom: 0;
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
	.video-cover-box-play{
		position: absolute;
		left: 0;
		top: 0;
		right: 0;
		bottom: 0;
		width: 100%;
		height: 100%;
		z-index: 1000;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		cursor: pointer;
	}
	.video-cover-box-play img{
		width: 56px;
		height: 56px;
	}
	.zhubo-user{
		position: absolute;
		top: 10px;
		right: 10px;
		z-index: 100;
		display: flex;
		flex-direction: row;
		align-items: center;
		cursor: pointer;
	}
	.zhubo-user span{
		font-family: MiSans, MiSans;
		font-weight: 400;
		font-size: 14px;
		color: #FFFFFF;
	}
	.zhubo-user img{
		margin-left: 6px;
		width: 16px;
		height: 16px;
	}
</style>
<style>
	.video-js{
		background: transparent ;
	}
</style>



// WEBPACK FOOTER //
// tengxunyunzhubo.vue?1e33a9a6